export default __webpack_public_path__ + "static/Uniting age well-22582cfff1583d763949e049b34fc929.svg";